import React, { useEffect } from 'react'
import cx from 'classnames'

import { toHHMMSS } from '../../../../../../shared/helpers.js'

import type { TrickPlayProps } from './types.js'

declare const COMPILING_FOR_COMCASTX1: boolean

export function TrickPlay({
  controlsPosition,
  seekLevel,
  trickImages,
  trickPlayUrl,
  isPaused,
}: TrickPlayProps) {
  const trickPlayCanvas = React.useRef<HTMLCanvasElement | null>(null)
  const drawTrickImage = (trickImageUrl: string = '') => {
    const leftStyleProperty = trickImageUrl.split('#xywh=')[1]?.split(',')[0]
    const topStyleProperty = trickImageUrl.split('#xywh=')[1]?.split(',')[1]

    const canvas = trickPlayCanvas.current
    const ctx = canvas?.getContext('2d')
    if (canvas !== null && ctx) {
      const img = new Image()
      img.src = trickImageUrl
      img.onload = () => {
        ctx.drawImage(
          img,
          parseInt(leftStyleProperty),
          parseInt(topStyleProperty),
          160,
          90,
          0,
          0,
          canvas.width,
          canvas.height
        )
      }
    }
  }

  const getTrickImage = (position: number) => {
    let trickImage: VTTCue
    if (trickImages[position]) {
      trickImage = trickImages[position]
    } else {
      const times = Object.keys(trickImages)
      let n = 0
      let closestTime = 0
      do {
        closestTime = parseInt(times[n])
        n++
      } while (closestTime - position < 0)
      trickImage = trickImages[closestTime]
    }
    const urlDivided = trickPlayUrl?.split('/')
    const imageUrl = trickPlayUrl.replace(
      `/${urlDivided.pop()}`,
      trickImage?.text
    )
    return imageUrl
  }

  useEffect(() => {
    const image = getTrickImage(controlsPosition)
    drawTrickImage(image)
  }, [controlsPosition])

  return (
    <div className="trick-play-container">
      <canvas
        className="trick-play-canvas"
        ref={trickPlayCanvas}
        width="320"
        height="180"
      />
      <div
        id="playhead-position"
        className={cx('playhead-position', {
          'extra-width': controlsPosition > 3600,
          'is-comcast': COMPILING_FOR_COMCASTX1,
        })}
      >
        <div className="icon-container left">
          {seekLevel < 0 && (
            <>
              <span className={cx('seek-icon', 'rewind', 'show')} />
              <span className="speed-text">
{Math.abs(seekLevel)}
x
              </span>
            </>
          )}
        </div>
        <div className="time-container">
          <span className="time">{toHHMMSS(controlsPosition)}</span>
        </div>
        <div className="icon-container right">
          <span
            className={cx('play-pause-icon', {
              paused: isPaused,
              show: seekLevel === 0,
            })}
          />
          {seekLevel > 0 && (
            <>
              <span className="speed-text">
{seekLevel}
x
              </span>
              <span className={cx('seek-icon', 'show')} />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
